import useViewModel from "./viewModel";
import View from "./view";

const Favorites = () => {
  const viewModel = useViewModel();

  return <View {...viewModel} />;
};

export default Favorites;
